// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3wsY0","savePackageButton":"ClientWallet_savePackageButton__d3IVh"};